export enum EDSFieldValidationState {
  Undefined = 'Undefined',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
  Default = 'Default',
}
